export default { sha: '2948d29def069ce3a0465833069c16b0fc999db9', buildNumber: 'undefined' }
